import ScrollableBarChart from "./scroll-bar";
export default ScrollableBarChart;
